import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Köttbutiken: etiketterna på produktsidan (blocks/kb-etiketter.liquid).
 * Byter innehåll när kunden väljer en annan variant, så att kampanjetikettens procent och
 * Slutsåld följer varianten. Samma mönster som product-price.js.
 */
class KbEtiketterComponent extends Component {
  /** @type {Element | null} */
  #sektion = null;

  connectedCallback() {
    super.connectedCallback();
    this.#sektion = this.closest('.shopify-section, dialog');
    this.#sektion?.addEventListener(StandardEvents.productSelect, this.#vidVariantbyte);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#sektion?.removeEventListener(StandardEvents.productSelect, this.#vidVariantbyte);
  }

  /** @param {any} event */
  #vidVariantbyte = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;
        const ny = detail.html.querySelector(`kb-etiketter-component[data-block-id="${this.dataset.blockId}"]`);
        if (!ny) return;
        this.innerHTML = ny.innerHTML;
        this.hidden = ny.hidden;
      })
      .catch(() => {});
  };
}

if (!customElements.get('kb-etiketter-component')) {
  customElements.define('kb-etiketter-component', KbEtiketterComponent);
}
